module.exports = __webpack_public_path__ + "static/blue-arrow-down-2a1b95bfc51585ab75f03ae18b6eb9cf.webp";